/**
 * @remarks Reviewers should confirm loading, error, and i18n paths when modifying this file.
 * @remarks Contributors should run client tests and production build before opening a PR.
 * @see Sonar quality gate — maintain comment density and low cyclomatic complexity.
 */
/**
 * @description Maintainability notes for Sonar and future contributors:
 * - Prefer small functions and hooks over monolithic components.
 * - Extract shared literals, styles, and helpers instead of copying blocks.
 * - Document non-obvious business rules with short comments or JSDoc tags.
 * - Keep API access in logic/ modules; keep UI state in hooks/components.
 * - Use stable React keys and memoized handlers in list-heavy views.
 * - Add or update unit tests when changing conditional flows or payments.
 */
/**
 * @fileoverview Client module `CertificationsCapacityField` for the Caintra Connect frontend.
 * @module components/AppointmentRegistrationSections/Certifications/CertificationsCapacityField
 *
 * Conventions:
 * - Keep components focused on rendering; move branching logic into hooks or utils.
 * - Prefer named exports for helpers and default exports for React components.
 * - Reuse shared validation, i18n, and API helpers from client/src/utils and logic/.
 */
const CertificationsCapacityField = ({
  company,
  t,
  styles,
  isTablet,
  missingRequiredFields,
  getFieldValidation,
  getFieldValidationState,
  getErrorMessage,
  onInputChange,
  onValidatedFieldChange,
}) => {
  if (!company || !Object.hasOwn(company, "capacidadInstalada")) {
    return null;
  }

  return (
    <div
      className={`${styles.inputRow} ${isTablet ? styles.tabletInputRow : ""}`}
    >
      <div className={styles.inputGroup}>
        <label className={styles.inputLabel}>
          {t("components.certifications.capacityAndTechnologiesLabel")}
          {missingRequiredFields &&
            Object.hasOwn(missingRequiredFields, "capacidadInstalada") && (
              <span className={styles.required}> *</span>
            )}
        </label>
        <div className={styles.textareaWrapper}>
          <textarea
            className={`${styles.capacityAndTechnologiesInput} ${
              getFieldValidationState(
                "capacidadInstalada",
                company?.capacidadInstalada || "",
              ) === "error" ||
              (getFieldValidation && getFieldValidation("capacidadInstalada"))
                ? styles.inputError
                : ""
            }`}
            placeholder={t(
              "components.certifications.capacityAndTechnologiesPlaceholder",
            )}
            value={company?.capacidadInstalada || ""}
            onChange={(event) => {
              const value = event.target.value;
              onInputChange("capacidadInstalada", value);
              onValidatedFieldChange("capacidadInstalada", value);
            }}
            maxLength={300}
          />
          <span className={styles.characterCounter}>
            {(company?.capacidadInstalada || "").length}/300
          </span>
        </div>
        {getErrorMessage("capacidadInstalada") && (
          <p className={styles.errorMessage}>
            {getErrorMessage("capacidadInstalada")}
          </p>
        )}
      </div>
    </div>
  );
};

export default CertificationsCapacityField;
